import { inject, injectable } from 'inversify'
import {
  IAppErrorFactory,
  IUpdatePasswordUseCase,
  IViewerService,
  UpdatePasswordUseCaseInput,
  UpdatePasswordUseCaseOutput,
} from '@/types'
import symbols from '@/symbols'

@injectable()
export default class UpdatePasswordInteractor implements IUpdatePasswordUseCase {
  @inject(symbols.IViewerService) private viewerService: IViewerService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: UpdatePasswordUseCaseInput): Promise<UpdatePasswordUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      await this.viewerService.updateMe(input)

      output.isSuccessful = true
    } catch (e) {
      output.isSuccessful = false
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: 'パスワードの変更に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): UpdatePasswordUseCaseOutput {
    return {
      isSuccessful: false,
      error: null,
    }
  }
}
